import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Badge } from '../../../components/badge/badge.index';
import { Divider, Spin, Typography } from 'antd';
import CoinIcon from '../../../../utilities/components/coinIcon/coinIcon.index';
import { OrderTransaction, Transaction, OrderTransactionDetail } from '../../../../interfaces';
import { formatCardNumber, get, getOrderTransactionBadgeType, priceDigit } from '../../../../scripts';
import moment from 'jalali-moment';
import { API } from 'data/30pay.api';

interface Props {
    item: OrderTransactionDetail;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export const OrderTransactionDetailModal: FC<Props> = ({ open, setOpen, item }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const details = item;
    // const [details, setDetails] = useState<item | null>(null);

    return (
        <Spin className="min-h-24" spinning={loading}>
            {details ? (
                <>
                    <div className="grid grid-cols-2 gap-4">
                        {details.orderTransactionTrackingCode ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">شماره پیگیری</Typography.Text>
                                <Typography.Text copyable className="en text-right">
                                    {details.orderTransactionTrackingCode}
                                </Typography.Text>
                            </div>
                        ) : null}

                        {details.orderTransactionState ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">وضعیت</Typography.Text>
                                <Badge
                                    type={
                                        getOrderTransactionBadgeType(details.orderTransactionState.id) as
                                        | 'success'
                                        | 'warning'
                                        | 'danger'
                                        | 'info'
                                    }
                                    className="w-fit"
                                    title={details.orderTransactionState.title}
                                />
                            </div>
                        ) : null}

                        {details.orderTransactionType ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">نوع</Typography.Text>
                                <span className="font-medium text-sm">{details.orderTransactionType.title}</span>
                            </div>
                        ) : null}

                        {details.createdOn ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">تاریخ ایجاد</Typography.Text>
                                <Typography.Text>
                                    {moment.utc(details.createdOn).locale('fa').local().format('jYYYY/jM/jD - HH:mm')}
                                </Typography.Text>
                            </div>
                        ) : null}

                        {details.sourceSymbol ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">ارز مبدأ</Typography.Text>
                                <div className="flex items-center gap-1">
                                    <CoinIcon symbol={details.sourceSymbol} size="small" />
                                    <Typography.Text className="en">{details.sourceSymbol}</Typography.Text>
                                </div>
                            </div>
                        ) : null}

                        {details.destinationSymbol ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">ارز مقصد</Typography.Text>
                                <div className="flex items-center gap-1">
                                    <CoinIcon symbol={details.destinationSymbol} size="small" />
                                    <Typography.Text className="en">{details.destinationSymbol}</Typography.Text>
                                </div>
                            </div>
                        ) : null}

                        {details.sourceAmount ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">مقدار مبدأ</Typography.Text>
                                <div className="flex items-center gap-1">
                                    <Typography.Text className="en">
                                        {priceDigit(details.sourceAmount)} {details.sourceSymbol}
                                    </Typography.Text>
                                </div>
                            </div>
                        ) : null}

                        {details.destinationAmount ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">مقدار مقصد</Typography.Text>
                                <div className="flex items-center gap-1">
                                    <Typography.Text className="en">
                                        {priceDigit(details.destinationAmount)} {details.destinationSymbol}
                                    </Typography.Text>
                                </div>
                            </div>
                        ) : null}

                        {details.deposit ? (
                            <>
                                {/* {details.deposit.amount ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">مقدار</Typography.Text>
                            <Typography.Text copyable ellipsis>
                                {details.deposit.amount.toLocaleString()} تومان
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {details.deposit.txId ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">هش</Typography.Text>

                                        <Typography.Text
                                            copyable={{ text: details.deposit.txId }}
                                            className="en !text-right flex items-center"
                                        >
                                            <p className="!mb-0 text-ellipsis overflow-hidden whitespace-nowrap en">
                                                {details.deposit.txId}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.deposit.symbol ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">نماد ارز واریز</Typography.Text>
                            <Typography.Text className="en text-right">{details.deposit.symbol}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.deposit.trackingCode ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">کد پیگیری واریز</Typography.Text>
                            <Typography.Text copyable ellipsis className="en text-right">
                                {details.deposit.trackingCode}
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {details.deposit.network?.name ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">شبکه</Typography.Text>
                                        <Typography.Text className="en text-right">
                                            {details.deposit.network.name}
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.deposit.network?.fee ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">کارمزد شبکه</Typography.Text>
                            <Typography.Text>
                                {details.deposit.network.fee.toLocaleString()} {details.deposit.symbol}
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.deposit.wallet?.walletAddress ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">آدرس کیف پول</Typography.Text>
                            <Typography.Text copyable ellipsis className="en text-right">
                                {details.deposit.wallet.walletAddress}
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.deposit.wallet?.memo ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">ممو</Typography.Text>
                            <Typography.Text copyable ellipsis className="en text-right">
                                {details.deposit.wallet.memo}
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {details.deposit.bankAccount?.bankName ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">نام بانک</Typography.Text>
                                        <Typography.Text>{details.deposit.bankAccount.bankName}</Typography.Text>
                                    </div>
                                ) : null}

                                {details.deposit.bankAccount?.cardNumber ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">
                                            شماره کارت
                                        </Typography.Text>
                                        <Typography.Text>
                                            {formatCardNumber(details.deposit.bankAccount.cardNumber)}
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.deposit.bankAccount?.iBan ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">شماره شبا</Typography.Text>
                            <Typography.Text>{details.deposit.bankAccount.iBan}</Typography.Text>
                        </div>
                    ) : null} */}

                                {details.deposit.voucher?.batchNumber ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">بچ نامبر</Typography.Text>
                                        <Typography.Text
                                            copyable={{ text: details.deposit.voucher.batchNumber }}
                                            className="en !text-right flex items-center"
                                        >
                                            <p className="!mb-0 text-ellipsis overflow-hidden whitespace-nowrap en">
                                                {details.deposit.voucher.batchNumber}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.deposit.voucher?.voucherCode ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">کد ووچر</Typography.Text>
                                        <Typography.Text
                                            copyable={{ text: details.deposit.voucher.voucherCode }}
                                            className="en !text-right flex items-center"
                                        >
                                            <p className="!mb-0 text-ellipsis overflow-hidden whitespace-nowrap en">
                                                {details.deposit.voucher.voucherCode}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.deposit.voucher?.voucerhActivationCode ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">کد فعال‌سازی ووچر</Typography.Text>
                            <Typography.Text>{details.deposit.voucher.voucerhActivationCode}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.deposit.transactionState?.title ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">وضعیت تراکنش</Typography.Text>
                            <Typography.Text>{details.deposit.transactionState.title}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.deposit.transactionType?.title ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">نوع تراکنش</Typography.Text>
                            <Typography.Text>{details.deposit.transactionType.title}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.deposit.receptMedia?.fileName ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">نام فایل رسید</Typography.Text>
                            <Typography.Text>{details.deposit.receptMedia.fileName}</Typography.Text>
                        </div>
                    ) : null} */}

                                {details.deposit.digitalReceipt ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">
                                            رسید دیجیتال
                                        </Typography.Text>
                                        <Typography.Text>{details.deposit.digitalReceipt}</Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.deposit.paidAt ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">تاریخ پرداخت</Typography.Text>
                            <Typography.Text>
                                {moment.utc(details.deposit.paidAt).locale('fa').local().format('jYYYY/jM/jD - HH:mm')}
                            </Typography.Text>
                        </div>
                    ) : null} */}
                            </>
                        ) : null}

                        {details.withdrawal ? (
                            <>
                                {/* {details.withdrawal.amount ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">مقدار</Typography.Text>
                            <Typography.Text copyable ellipsis>
                                {details.withdrawal.amount.toLocaleString()} تومان
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.withdrawal.symbol ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">نماد ارز واریز</Typography.Text>
                            <Typography.Text className="en text-right">{details.withdrawal.symbol}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.withdrawal.trackingCode ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">کد پیگیری واریز</Typography.Text>
                            <Typography.Text copyable ellipsis className="en text-right">
                                {details.withdrawal.trackingCode}
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {details.withdrawal.network?.name ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">شبکه</Typography.Text>
                                        <Typography.Text className="en text-right">
                                            {details.withdrawal.network.name}
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.network?.fee ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">
                                            کارمزد شبکه
                                        </Typography.Text>
                                        <Typography.Text>
                                            <div className="flex items-center flex-row-reverse justify-end gap-1">
                                                <p className="!mb-0">{priceDigit(details.withdrawal.network.fee)}</p>
                                                <p className="en !mb-0"> {details.withdrawal.symbol}</p>
                                            </div>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.txId ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">هش</Typography.Text>
                                        <Typography.Text
                                            copyable={{ text: details.withdrawal.txId }}
                                            className="en !text-right flex items-center"
                                        >
                                            <p className="!mb-0 text-ellipsis overflow-hidden whitespace-nowrap en">
                                                {details.withdrawal.txId}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.wallet?.walletAddress ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">
                                            آدرس کیف پول
                                        </Typography.Text>
                                        <Typography.Text
                                            copyable={{ text: details.withdrawal.wallet.walletAddress }}
                                            className="en text-right flex items-center gap-1"
                                        >
                                            <p className="en whitespace-nowrap overflow-hidden text-ellipsis !mb-0">
                                                {' '}
                                                {details.withdrawal.wallet.walletAddress}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.wallet?.memo ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">ممو</Typography.Text>
                                        <Typography.Text copyable ellipsis className="en text-right">
                                            {details.withdrawal.wallet.memo}
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.bankAccount?.bankName ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">نام بانک</Typography.Text>
                                        <Typography.Text>{details.withdrawal.bankAccount.bankName}</Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.withdrawal.bankAccount?.cardNumber ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">شماره کارت</Typography.Text>
                            <Typography.Text>
                                {formatCardNumber(details.withdrawal.bankAccount.cardNumber)}
                            </Typography.Text>
                        </div>
                    ) : null} */}

                                {details.withdrawal.bankAccount?.iBan ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">شماره شبا</Typography.Text>
                                        <Typography.Text>{details.withdrawal.bankAccount.iBan}</Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.voucher?.batchNumber ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">بچ نامبر</Typography.Text>
                                        <Typography.Text
                                            copyable={{ text: details.withdrawal.voucher.batchNumber }}
                                            className="en !text-right flex items-center"
                                        >
                                            <p className="!mb-0 text-ellipsis overflow-hidden whitespace-nowrap en">
                                                {details.withdrawal.voucher.batchNumber}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {details.withdrawal.voucher?.voucherCode ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">کد ووچر</Typography.Text>
                                        <Typography.Text
                                            copyable={{ text: details.withdrawal.voucher.voucherCode }}
                                            className="en !text-right flex items-center"
                                        >
                                            <p className="!mb-0 text-ellipsis overflow-hidden whitespace-nowrap en">
                                                {details.withdrawal.voucher.voucherCode}
                                            </p>
                                        </Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.withdrawal.voucher?.voucerhActivationCode ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">کد فعال‌سازی ووچر</Typography.Text>
                            <Typography.Text>{details.withdrawal.voucher.voucerhActivationCode}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.withdrawal.transactionState?.title ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">وضعیت تراکنش</Typography.Text>
                            <Typography.Text>{details.withdrawal.transactionState.title}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.withdrawal.transactionType?.title ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">نوع تراکنش</Typography.Text>
                            <Typography.Text>{details.withdrawal.transactionType.title}</Typography.Text>
                        </div>
                    ) : null} */}

                                {/* {details.withdrawal.receptMedia?.fileName ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">نام فایل رسید</Typography.Text>
                            <Typography.Text>{details.withdrawal.receptMedia.fileName}</Typography.Text>
                        </div>
                    ) : null} */}

                                {details.withdrawal.digitalReceipt ? (
                                    <div className="flex flex-col">
                                        <Typography.Text className="font-bold text-gray-500">
                                            رسید دیجیتال
                                        </Typography.Text>
                                        <Typography.Text>{details.withdrawal.digitalReceipt}</Typography.Text>
                                    </div>
                                ) : null}

                                {/* {details.withdrawal.paidAt ? (
                        <div className="flex flex-col">
                            <Typography.Text className="font-bold text-gray-500">تاریخ پرداخت</Typography.Text>
                            <Typography.Text>
                                {moment
                                    .utc(details.withdrawal.paidAt)
                                    .locale('fa')
                                    .local()
                                    .format('jYYYY/jM/jD - HH:mm')}
                            </Typography.Text>
                        </div>
                    ) : null} */}
                            </>
                        ) : null}

                        {details.attachedMessage ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">پیام پیوست</Typography.Text>
                                <Typography.Text>{details.attachedMessage}</Typography.Text>
                            </div>
                        ) : null}

                        {details.onPrice && (
                            (details.orderTransactionType?.id === 1 && ['UUSD', 'USDT'].includes((details.destinationSymbol?.toUpperCase() || ''))) ||
                            (details.orderTransactionType?.id === 2 && ['UUSD', 'USDT'].includes((details.sourceSymbol?.toUpperCase() || '')))
                        ) ? (
                            <div className="flex flex-col">
                                <Typography.Text className="font-bold text-gray-500">قیمت لحظه ای</Typography.Text>
                                <Typography.Text>{details.onPrice.toLocaleString()} تومان</Typography.Text>
                            </div>
                        ) : null}
                    </div>
                </>
            ) : null}
        </Spin>
    );
};
